/**
 * Статусы лида портала (`GET /api/leads/statuses`) и перевод лида в «В работе» или в отказ
 * (`POST /api/leads/{id}/status`). Запись идёт в боевой Bitrix с журналом `bitrix_write_log`;
 * действие, включая неудачное, — строка `user_action`. «В работе» — с датой следующей обработки:
 * выбранной или по правилу Резерва (`GET /api/leads/{id}/next-work`), спека
 * `docs/specs/2026-10-20-lead-next-work-design.md`.
 */
import { apiFetch } from "@/lib/api";

/** new — «Не обработан», work — «В работе», refuse — отказ, won — стал сделкой. */
export type LeadStatusKind = "new" | "work" | "refuse" | "won";
export type LeadStatus = { code: string; name: string; kind: LeadStatusKind };
export type LeadStatusResult = {
  id: number;
  status: string;
  status_name: string;
  /** Дата следующей обработки после записи, `ГГГГ-ММ-ДДTЧЧ:ММ` (полночь — без времени). */
  next_at: string | null;
  next_rule: string | null;
  was: { status: string; status_name: string | null };
};
/** Рекомендация по правилу Резерва: `at` и почему (`rule`); `current` — что стоит в лиде сейчас. */
export type LeadNextWork = { at: string; rule: string; calls: number; current: string | null };

export const loadLeadNextWork = (leadId: number) => apiFetch<LeadNextWork>(`/api/leads/${leadId}/next-work`);

export const loadLeadStatuses = () => apiFetch<{ statuses: LeadStatus[] }>("/api/leads/statuses");
export const setLeadStatus = (leadId: number, status: string, chatId?: number, nextAt?: string) =>
  apiFetch<LeadStatusResult>(`/api/leads/${leadId}/status`, {
    method: "POST",
    body: JSON.stringify({ status, chat_id: chatId ?? null, next_at: nextAt || null }),
  });
